import React from 'react';
import BadgeForm from './BadgeForm';

export default function BadgesNew({ history }) {
  return <BadgeForm initialData={null} docId={null} history={history} />;
}
